import { Table, TableColumnsType } from "antd";
import moment from "moment";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getDashboardNotice } from "../../../api/dashboard.api";
import useAxios from "../../../hooks/useAxios";
import { IDashboardNotice, IGetDashboardNotice } from "../../../models/dashboard.model";
import { RootState } from "../../../store/rootReducer";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import Subtitle from "./Subtitle";
import { useHistory } from "react-router-dom";

const Notice = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { data: res, isLoading, error, execute } = useAxios<IGetDashboardNotice>();

  useEffect(() => {
    if (currentCampus) {
      execute(getDashboardNotice(currentCampus));
    }
  }, [currentCampus]);

  const columns: TableColumnsType<IDashboardNotice> = [
    {
      title: t('class.dashboard.column33'),
      dataIndex: 'title',
      key: 'title',
      align: 'center',
    },
    {
      title: t('class.dashboard.column34'),
      dataIndex: 'regDate',
      key: 'regDate',
      align: 'center',
      render: value => moment(value).format('YYYY.MM.DD'),
    },
  ];

  return (
    <>
      {isLoading && <Loader />}
      <ErrorResponse error={error} />

      <Subtitle
        text={t('class.dashboard.title12')}
        path="/board/notice"
      />
      <Table
        className='comm-table__area'
        columns={columns}
        dataSource={res?.data}
        onRow={(record) => {
          return {
            onClick: () => {
              history.push(
                `/board/notice/${record.noticeCode}`,
              );
            },
          };
        }}
        rowClassName="pointer"
      />
    </>
  );
}

export default Notice;
